import paper from "paper";
import { makePaperProject } from "./utils.js";

export const getDataUrlFromSVG = async (svg_el) => {
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();

  makePaperProject(paper_scope);
  let data_url;
  let canvas;

  paper_scope.project.importSVG(svg_el, {
    onLoad: (item) => {
      const raster = item.rasterize();
      data_url = raster.toDataURL();
      canvas = raster.canvas;
    },
  });
  paper_scope.remove();
  paper_scope = null;
  console.log(data_url);
  return Promise.resolve({ canvas, data_url });
};
